import { Box, Button, Modal } from "@mui/material";
import React from "react";
import { APIDataUrl, APITokenUrl } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
const MessageModal = ({
  open,
  setOpen,
  message,
  handleSubmit,
  length,
  showBtn,
  handleArchiveRecords,
  
}) => {
  
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "450px",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="vrufyerv">
        <Box sx={style} style={{ overflowY: "auto" }}>
          <div className="de_pad">
          <h3>{message}</h3>  
            {length ? <p>{length} record selected</p> : null}
            <div className="de_hr">
              <div className="de_btn_cont">
                {showBtn === false ? null : (
                  <Button
                    className="de_cancel"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    No
                  </Button>
                )}
                <Button className="de_next" onClick={handleSubmit}>
                  Yes
                </Button>
                {/* <div>
                                    {favoritesList?.length > 0 && (
                                        <Button className='de_next' onClick={() => handleRemoveFavouriteLead(favoritesList[0]?.favourites_id)}>
                                            Yes
                                        </Button>
                                    )}
                                </div> */}
                {/* <Button className='de_next' onClick={handleSubmit} >{showBtn === false ? "Go Back" : "Yes"}</Button> */}
              </div>
            </div>
          </div>
        </Box>
      </div>
    </Modal>
  );
};
export default MessageModal;

// import { Box, Button, Modal } from '@mui/material';
// import React from 'react';
// import { APIDataUrl, APITokenUrl } from '../../Utils/Utils';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// const MessageModal = ({ open, setOpen, message, handleSubmit, length, showBtn, favoritesList, listFavoriteRecords, handleArchiveRecords }) => {
//     const style = {
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         width: 450,
//         bgcolor: "background.paper",
//         boxShadow: 24,
//         borderRadius: "8px",
//     };

//     // const handleRemoveFavouriteLead = (favourites_id) => {
//     //     const option = {
//     //         method: "POST",
//     //         headers: {
//     //             "access-control-allow-origin": "*",
//     //             "content-type": "application/json",
//     //             "X-API-Key": APITokenUrl()
//     //         },
//     //         url: `${APIDataUrl()}/v1/remove_favourite_leads?id=${favourites_id}`,
//     //     };
//     //     axios(option)
//     //         .then(async (response) => {
//     //             listFavoriteRecords();
//     //             handleArchiveRecords();
//     //         })
//     //         .catch(() => {
//     //             toast.error("Failed to remove from favorites");
//     //         });
//     // };

//     return (
//         <Modal
//             open={open}
//             aria-labelledby="modal-modal-title"
//             aria-describedby="modal-modal-description"
//         >
//             <div className="vrufyerv">
//                 <Box sx={style} style={{ overflowY: "auto" }}>
//                     <div className="de_pad">
//                         <h3>{message}</h3>
//                         {
//                             length ?
//                                 <p>{length} record selected</p> : null
//                         }
//                         <div className="de_hr">
//                             <div className='de_btn_cont'>
//                                 {
//                                     showBtn === false ? null :
//                                         <Button className='de_cancel' onClick={() => { setOpen(false) }} >No</Button>
//                                 }
//                                 {favoritesList?.length > 0 ? (
//                                     <Button className="de_next" onClick={() => handleRemoveFavouriteLead(favoritesList[0]?.favourites_id)}>
//                                         Yes
//                                     </Button>
//                                 ) : (
//                                     <Button className="de_next" onClick={handleSubmit}>
//                                         Yes
//                                     </Button>
//                                 )}
//                                 {/* <div>
//                                     {favoritesList?.length > 0 && (
//                                         <Button className='de_next' onClick={() => handleRemoveFavouriteLead(favoritesList[0]?.favourites_id)}>
//                                             Yes
//                                         </Button>
//                                     )}
//                                 </div> */}
//                                 {/* <Button className='de_next' onClick={handleSubmit} >{showBtn === false ? "Go Back" : "Yes"}</Button> */}
//                             </div>
//                         </div>
//                     </div>
//                 </Box>
//             </div>
//         </Modal>
//     )
// }

// export default MessageModal
